import React from 'react';
import './styles.less';
import { WBNMap } from 'components/molecules';
import { Button } from 'components/atoms';
import Helmet from 'react-helmet';

const Segment = ({ children, minHeight = '150px', width = '200px', ...props }) => {
	return (
		<div
			style={{
				borderRadius: '10px',
				maxWidth: '833px',
				maxHeight: '600px',
				fontSize: '12px',
				margin: '20px 0',
				padding: '10px',
				backgroundColor: 'var(--wbn-primary-color_navbar)'
			}}
			{...props}
		>
			{children}
		</div>
	);
};
const AboutUs = () => {
	window.scrollTo(0, 0);
	return (
		<div>
			<Helmet>
				<title>
					{`WBN in ${process.env.REACT_APP_SEO_SECOND} helps companies to connect with B2B distributors, ${process.env.REACT_APP_SEO_FIRST} buyers and industrial
					manufacturers to establish and/or to improve business relationship, confidence and profit at very
					low cost, making Import and Export trade available in few clicks`}
				</title>
				<meta
					name="description"
					content={`WBN helps in ${process.env.REACT_APP_SEO_SECOND} companies to connect with global B2B distributors, ${process.env.REACT_APP_SEO_SECOND} buyers and industrial manufacturers to establish and/or to improve ${process.env.REACT_APP_SEO_SECOND} business relationship, confidence and profit at very low cost, making Import and Export trade available for everyone in few clicks, made in ${process.env.REACT_APP_SEO_SECOND} We help companies to connect with B2B distributors, buyers and industrial manufacturers to establish and/or to improve business relationship, confidence and profit at very low cost, making Import and Export trade available for everyone in few clicks. ${process.env.REACT_APP_SEO_FIRST} B2B industrial export IT manufacturing supplies, made in ${process.env.REACT_APP_SEO_SECOND} manufacturing vendors for B2B global distributors, WBN your best source of manufacturer suppliers and vendors, ${process.env.REACT_APP_SEO_FIRST} business guide is part of WBN industrial b2b social network, made in ${process.env.REACT_APP_SEO_SECOND} export products manufacturing business supply, ${process.env.REACT_APP_SEO_FIRST} products for wholesale business distributors in United States, Asia, Africa, Europe, South America, Latin America and Middle East distribution, WBN the industrial b2b social network for wholesalers and manufacturing private label industries, made in ${process.env.REACT_APP_SEO_SECOND} products manufacturer supplier for wholesalers and vendors of the market, industrial products for wholesale worldwide distributors, ${process.env.REACT_APP_SEO_FIRST} electronic products manufacturing for private label buyers and new brand for manufacturer, business to business manufacturing supplies and market distributors, ${process.env.REACT_APP_SEO_FIRST} product manufacturing industry looking for worldwide distributors mainly in Germany, Denmark, Austria, Portugal, Spain, France, Norway, Sweden in Europe, China, Japan, Korea, Vietnam in Asia, California, New York, Florida, Chicago Illinois and all the United States of America, South Arabia, Qatar, Oman, UAE, Middle East, Australia, North of Africa, South America and all Latin America`}
				/>
				<meta
					name="keywords"
					content={`${process.env.REACT_APP_SEO_FIRST} wbn mission,  ${process.env.REACT_APP_SEO_FIRST} wbn vision, helps ${process.env.REACT_APP_SEO_SECOND} distributors, manufacturing social network, b2b social network, industrial social network, ${process.env.REACT_APP_SEO_SECOND} social network`}
				/>
			</Helmet>
			<div>
				<p style={{ textAlign: 'center', padding: '5px 10px' }}>WBN MISSION, VISION & VALUES</p>
				<p style={{ textAlign: 'center', padding: '5px 10px' }}>
					As managers of WBN Inc. we look everyday into the ever-changing dynamics of world business to
					business, working hard to be ahead with new ideas to innovate our services and provide fruitful
					benefits to companies everywhere. Following we have defined our mission, vision and values thinking
					in each of our customer needs and market requirements.
				</p>
			</div>

			<div className="container-message">
				<Segment className="container-message__segment">
					<div className="container-message__segment-element">
						<div className="container-message__segment-image">
							<img className="container-message__segment-image--mission" src={`/img/domain/${process.env.REACT_APP_DOMAIN_NAME}/DABIE/DABIE_1_${process.env.REACT_APP_DOMAIN_NAME}.svg`} alt="DABIE" />
						</div>
						<div className="container-message__segment-text">
							<Button>WBN MISSION</Button>
							<p>
								We help companies to connect with B2B distributors, buyers and industrial manufacturers to
								establish and/or to improve business relationship, confidence and profit at very low cost,
								making Import and Export trade available for everyone in few clicks
							</p>
						</div>
					</div>
				</Segment>
				<Segment className="container-message__segment">
					<div className="container-message__segment-element">
						<div className="container-message__segment-text" style={{ justifyContent: 'center' }}>
							<p>
								To be the world leader B2B industrial tool, innovating our resources with the latest
								technology to offer, everyone and everywhere, a real chance to be successful into the global
								market.
							</p>
						</div>
						<div className="container-message__segment-image">
							<img className="container-message__segment-image--vision" src={`/img/domain/${process.env.REACT_APP_DOMAIN_NAME}/DABIE/DABIE_2_${process.env.REACT_APP_DOMAIN_NAME}.svg`} alt="DABIE" />
						</div>
					</div>
				</Segment>
				<Segment className="container-message__segment">
					<div className="container-message__segment-element">
						<div className="container-message__segment-image">
							<img className="container-message__segment-image--values" src={'/img/mission-vision/vision_wbnb2b_industrial_b2b_social_network.png'} alt="DABIE" />
						</div>
						<div className="container-message__segment-text">
							<Button>WBN VALUES</Button>
							<ul>
								<li>PEOPLE We believe that people come first and can devise or transform anything</li>
								<li>
									INNOVATION to develop new ideas, inventions, creative thoughts and solutions to exceed
									customer requirements and market needs
								</li>
								<li>GLOBAL MENTALITY we belive that diversity and respect make us stronger</li>
								<li>PASSION we transmit passion in what we do, it's the engine of our organization</li>
								<li>HONESTY is what we demand from ourselves and from our team</li>
								<li>EXCELLENCE we care about details and we want to be better every day</li>
							</ul>
						</div>
					</div>
				</Segment>
			</div>
			<WBNMap />
		</div>
	);
};

export default AboutUs;
